import { c as _c } from "react/compiler-runtime";
interface DocTituloSecaoProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}
export function DocTituloSecao(t0) {
  const $ = _c(7);
  const {
    icon,
    children
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <div className="bg-brand-600/10 text-brand-600 flex h-7 w-7 flex-none items-center justify-center rounded-[7px]">{icon}</div>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <h2 className="text-brand-600 m-0 text-[14px] font-bold tracking-[1px] uppercase">{children}</h2>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="mb-[14px] flex items-center gap-[14px]">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}